/**
 * @file IconProductRecruitment Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-product-recruitment',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="16421"
  t="1683609833185"
  viewBox="0 0 1024 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M113.749333 441.770667h796.501334v85.333333H113.749333z"
    p-id="16422"
  />
  <path
    fill="${data.colorDesc[0]}"
    d="M512.853333 682.922667a185.173333 185.173333 0 0 1-184.917333-184.832h85.333333a99.669333 99.669333 0 0 0 199.082667 0h85.333333c0 101.802667-82.773333 184.832-184.832 184.832z"
    p-id="16423"
  />
  <path
    fill="${data.colorDesc[0]}"
    d="M919.637333 1008.64H104.362667a99.584 99.584 0 0 1-72.533334-31.829333 102.314667 102.314667 0 0 1-26.709333-77.653334l47.530667-587.093333c4.266667-52.053333 47.786667-93.013333 99.242666-93.013333h720.213334c51.456 0 94.976 40.96 99.242666 93.013333l47.530667 587.093333c2.304 28.416-7.424 56.832-26.709333 77.653334-18.773333 20.138667-45.056 31.658667-72.533334 31.829333zM151.893333 304.384c-7.424 0-13.397333 6.485333-14.250666 14.506667l-47.189334 587.093333c-0.597333 6.485333 2.56 11.093333 4.266667 13.056a13.653333 13.653333 0 0 0 9.984 4.522667h814.933333a13.653333 13.653333 0 0 0 9.898667-4.522667 16.213333 16.213333 0 0 0 4.266667-13.056l-47.445334-586.837333c-0.597333-8.277333-6.826667-14.506667-14.250666-14.506667H151.893333v-0.256z"
    p-id="16424"
  />
  <path
    fill="${data.colorDesc[0]}"
    d="M768 261.717333H682.666667V161.28c0-33.28-31.829333-60.586667-71.082667-60.586667H412.416c-39.253333 0-71.082667 27.050667-71.082667 60.586667v100.437333H256V161.28C256 80.810667 326.229333 15.36 412.416 15.36h199.168C697.770667 15.36 768 80.810667 768 161.28v100.437333z"
    p-id="16425"
  />
</svg>
`
);
